import {useQuery} from 'react-query';
import {BuMonitoring} from '../Types/service';
import {GraphServiceType} from '../Types/graphPeriods';
import {getGraph, getMonitoring} from '../Api/api';

const MONITORING_QUERY_KEY = 'monitoring';
const MONITORING_GRAPH_QUERY_KEY = 'monitoring-graph';

export const useGetMonitoring = () =>
  useQuery<BuMonitoring[], unknown, BuMonitoring[]>(MONITORING_QUERY_KEY, () => getMonitoring());

export const useGetGraph = (
  buId: string,
  serviceType: GraphServiceType,
  periodHours: number,
  enabled: boolean,
) =>
  useQuery<{base64: string | null}, unknown, {base64: string | null}>(
    [MONITORING_GRAPH_QUERY_KEY, buId, serviceType, periodHours],
    () => getGraph(buId, serviceType, periodHours),
    {enabled, staleTime: 60_000},
  );
